export default __webpack_public_path__ + "static/media/nbp-logo.b6b76236.png";